const submitButton = document.getElementById(
  'submit-button',
) as HTMLButtonElement | null;

function preventDuplicates(): void {
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.textContent = 'Sending message';
  }
}

// Expose to global scope — called via onSubmit="preventDuplicates()" in cshtml views
globalThis.preventDuplicates = preventDuplicates;
